window.addEventListener('DOMContentLoaded', function() {
// Notes:
// 1. Each tab within the div has to have the exact same name as the id in content-body divs for the function to work properly. 


  //function to remove show-active class and add to clicked
  function setNewActive(el) {
    //select all content-body classes
    let DOMcontentBody = document.getElementsByClassName('content-body');
    //removes show-active from all content-body
    for(contentBody of DOMcontentBody) {
      contentBody.classList.remove('show-active');
    }
    
    // the clicked element is selected and displays the content-body
    console.log(el.currentTarget);
    document.getElementById(el.textContent).classList.add('show-active');
    
    // selects all tab classes
    let DOMtabsAll = document.getElementsByClassName('tab');
    // loops through all tabs and removes tab-active from all
    for(let tab of DOMtabsAll) {
      tab.classList.remove('tab-active');
    }
    
    // takes the clicked tab and makes it active
    el.classList.add('tab-active');
  }

  //select tab class and loop through
  let DOMtabsAll = document.getElementsByClassName('tab');
  for(let tab of DOMtabsAll) {
    //add a click event listener to each tab
    tab.addEventListener('click', function(e) {
      setNewActive(e.currentTarget);
      console.log(e.currentTarget);
    });
  }
});

//add show-active back to clicked
    //how do we know which one we clicked?
    //in teh eventListener the e argument on e.currentTarget will answer this question for us. 
